import _extends from "@babel/runtime/helpers/extends";
import { CustomItem, NestingItem, Section } from '@atlaskit/side-navigation';
import { getPartnerNavLinks } from '@atlassian/mpac-utils';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { nestedNav, SideNavIconsMapping, SideNavNames } from './PartnerSideNav.constants';
import { getAuthorisedNavList, getFirstNavItem } from './PartnerSideNav.utils';
export const PartnerSideNavItem = _ref => {
  let {
    navItem,
    selectedNavItems,
    authroisedNavItems,
    id
  } = _ref;
  const Icon = SideNavIconsMapping[navItem];
  const links = getPartnerNavLinks();
  if (nestedNav[navItem]) {
    return /*#__PURE__*/React.createElement(NestingItem, {
      id: navItem,
      isSelected: selectedNavItems.includes(navItem),
      title: SideNavNames[navItem],
      testId: "nested-".concat(navItem),
      component: props => /*#__PURE__*/React.createElement(RouteLink, _extends({}, props, {
        to: links[getFirstNavItem(nestedNav[navItem], authroisedNavItems)].expand({
          id
        })
      }), props.children),
      iconBefore: /*#__PURE__*/React.createElement(Icon, {
        label: SideNavNames[navItem]
      })
    }, /*#__PURE__*/React.createElement(PartnerSideNavContent, {
      navList: nestedNav[navItem],
      authroisedNavItems: authroisedNavItems,
      selectedNavItems: selectedNavItems,
      id: id
    }));
  }
  return /*#__PURE__*/React.createElement(CustomItem, {
    isSelected: selectedNavItems.includes(navItem),
    iconBefore: Icon && /*#__PURE__*/React.createElement(Icon, {
      label: SideNavNames[navItem]
    }),
    component: RouteLink,
    to: links[navItem].expand({
      id
    }),
    testId: "custom-".concat(navItem)
  }, SideNavNames[navItem]);
};
const PartnerSideNavContent = props => {
  const authorisedNavList = getAuthorisedNavList(props.navList, props.authroisedNavItems);
  return /*#__PURE__*/React.createElement(React.Fragment, null, authorisedNavList.map(list => /*#__PURE__*/React.createElement(Section, {
    isList: true,
    title: list.title,
    key: list.title,
    testId: "side-nav-list"
  }, list.navItems.map(navItem => /*#__PURE__*/React.createElement(PartnerSideNavItem, {
    navItem: navItem,
    selectedNavItems: props.selectedNavItems,
    key: SideNavNames[navItem],
    authroisedNavItems: props.authroisedNavItems,
    id: props.id
  })))));
};
export default PartnerSideNavContent;